export default __webpack_public_path__ + "images/3c1e5d85c28ba59128ce384167862ca8-mailchimp_logo.svg";